<template>
  <div>
    <div v-if="getLocaltypes()==1">
    <!-- <el-container> -->
      <div class="mytop">
        <div>
          <div class="head">
            <div class="topfont">
              <div v-show="false">
                <a href="">新冠肺炎疫情信息专栏</a>
                <a href="">信息公开</a>
                <a href="">学习超市</a>
                <a href="">图书馆</a>
              </div>
              <div class="loginandregister">
                <router-link to='/login'>{{$t('user.login')}}</router-link>
                <router-link to='/register'>{{$t('user.register')}}</router-link>
                <span @click="changeLanguage" v-show="true">语言切换</span>
                <!-- <router-link :to="{path:'/Sear',query:{infoID:16,styles:1}}">搜索</router-link> -->
              </div>
            </div>
          </div>
          <div class="headbutton">
            <div class="headfont">
              <!-- <div  @mouseout="remMenusClass()"> -->
                <el-menu class="el-menu-demo" mode="horizontal" background-color="#0065bd" ref="menu" text-color="#fff"
                unique-opened router @open="handleOpen" @close="handleClose" :default-active="$route.path"
                active-text-color="none">
                <el-menu-item index="/text" class="ments">
                  <div class="dd" @close="handleClose">
                    <div></div>
                    <div><span></span></div>
                  </div>
                </el-menu-item>

                <el-submenu :index="index+''" v-for="(info,index) in infolist" :key="index+'haha'" v-show="(info.isPublic1==true||$user!=null)" router class="menusClass"
                  @mouseover.native="getSubmenuIsActive(index)" :class="submenuIsActive===index? boderbuttomData :''">
                  <template slot="title">{{ getgeLanguage(info.infoNameEn)=='zh'?info.info_NAME:info.infoNameEn }}</template>
                       <!-- {{$t("nav1."+info.info_NAME)}} -->
                  <label  v-for="(text,index2) in info.info_classes" :key="index2+'ce'">
                  <el-menu-item :index="index2+''" :class="{'menusClass' : isActive===text.info_CLASS_ID}" v-if="(text.isMenus==true&&(text.isPublic==true||$user!=null))"
                    @mouseover.native="getmenusClass(text,index)" @mouseout.native="delmenusClass()"
                    :route="{path:'/'+text.router, query:{htmlpath : text.htmlPath,infoID:info.info_ID,two:text.info_CLASS_ID,styles:[index2],t: Date.now()}}"
                   >{{ getgeLanguage( text.infoClassNameEn)=='zh'? text.info_CLASS_NAME: text.infoClassNameEn}}
                  </el-menu-item>

                  <el-submenu :index="index2+'ceshi'" v-if="text.isMenus==false&&(text.isPublic==true||$user!=null)" :class="{'menusClass' : isActive===text.info_CLASS_ID}" @mouseover.native="getmenusClass(text,index)" @mouseout.native="delmenusClass()">
                    <template slot="title">{{ getgeLanguage( text.infoClassNameEn)=='zh'? text.info_CLASS_NAME: text.infoClassNameEn}}</template>

                    <label v-for="(item3,index3) in text.infoMenus" :key="index3+'3级'">
                   <el-menu-item :index="index3+''" v-if="(item3.isPublic3==true||$user!=null)" :route="{path:'/'+item3.router, query:{htmlpath : item3.htmlPath,infoID:info.info_ID,styles:[index2+'',index3+''],active:[index2],threeMenus:item3.info_ID,t: Date.now()}}" >{{ getgeLanguage( item3.infoMenusNameEn)=='zh'? item3.info_NAME: item3.infoMenusNameEn}} </el-menu-item>
</label>
                  </el-submenu>
                  
                </label>
                </el-submenu>
              </el-menu>
              <!-- </div> -->
            </div>
          </div>
        </div>
      </div>
    <!-- </el-container> -->
    <!-- <el-main class="viewList">
      <router-view :key="$route.query.t"></router-view>
    </el-main> -->
    <div style="margin-top: 120px;">
      <router-view :key="$route.query.t"></router-view>
    </div>
    
    
    <div class="footerBar2">
    <div class="contentBox">
    <div class="footer_logo">
       <img src="static/saw_new_logo.png" width="200" height="40">
         <img src="http://www.ebookware.cn/video/uws_logo.jpg" width="200" height="80">
    </div>
    <div class="footer_left">
       <p style="margin-left:10px"> <span><a href="https://www.uws.ac.uk/">{{$t('mainPage.UWSEn')}}</a></span></p>
        <p style="margin-left:10px"> <span><a href="https://www.uws.asia/">{{$t('mainPage.UWSCn')}}</a></span></p>
        <p style="margin-left:10px"> <span> <a href="http://www.wxu.edu.cn/">{{$t('mainPage.THU')}}</a> </span></p>
    </div>
    <div class="footer_mid">
      <p style="margin-left:10px"> <span>{{$t('mainPage.schoolAddress')}}</span></p>
       <p style="margin-left:10px"> <span>{{$t('mainPage.telephone')}}</span></p>
        <p style="margin-left:10px"> <span>{{$t('mainPage.phone')}}     {{$t('mainPage.fax')}}</span></p>
    </div>
    <div class="footer_right">
            <!-- <ul>
            <li class="i"> -->
                      <span> {{$t('mainPage.tencent')}}</span>
                      <div class="con" style="display: true;"><img src="http://www.ebookware.cn/video/saw_QR.png" width="120"></div>
            <!-- </li>
            </ul> -->
              <!-- <p style="margin-left:10px"> <span><a href="https://www.weibo.com/thxywb">学院公众号</a></span></p>
              <p style="margin-left:10px"> <span><a href="https://www.weibo.com/thxywb">学院微博</a></span></p> -->
    </div>
    </div>
    </div>

  </div>
  <div v-if="getLocaltypes()==2">
     <div>
      <div style="width: 100%; display: flex;
  justify-content: space-between;">
     <div style="" @click="$router.push('text')">
      <el-image
      style=" height: 50px;width: 100%;"
      src="http://www.wxu.edu.cn/r/cms/thxy/thxy2/images/logo.jpg"
      fit="scale-down"></el-image>
      <!-- <img src=""> -->
  </div>
  <div style="height: 50px;" @click="showMenu=true">
    <i style=" line-height: 50px;" class="el-icon-s-unfold"></i>
  </div>
     </div>
   
     </div>


     <div>
      <router-view :key="$route.query.t"></router-view>
    </div>
    <el-dialog
  :visible.sync="showMenu"
  width="100%"
 >
 <el-menu class="el-menu-demo" mode="vertical"  ref="menu" 
                unique-opened router @open="handleOpen" @close="handleClose" @select="handSelect" :default-active="$route.path"
                active-text-color="none">
                <el-menu-item index="/text" class="ments">
                  <div class="dd" @close="handleClose">
                    <div></div>
                    <div><span></span></div>
                  </div>
                </el-menu-item>

                <el-submenu :index="index+''" v-for="(info,index) in infolist" :key="index+'haha'" v-show="(info.isPublic1==true||$user!=null)" router class="menusClass"
                  @mouseover.native="getSubmenuIsActive(index)">
                  <template slot="title">{{ getgeLanguage(info.infoNameEn)=='zh'?info.info_NAME:info.infoNameEn }}</template>
                       <!-- {{$t("nav1."+info.info_NAME)}} -->
                  <label  v-for="(text,index2) in info.info_classes" :key="index2+'ce'">
                  <el-menu-item :index="index2+''"  v-if="(text.isMenus==true&&(text.isPublic==true||$user!=null))"
               
                    :route="{path:'/'+text.router, query:{htmlpath : text.htmlPath,infoID:info.info_ID,two:text.info_CLASS_ID,styles:[index2],t: Date.now()}}"
                   >{{ getgeLanguage( text.infoClassNameEn)=='zh'? text.info_CLASS_NAME: text.infoClassNameEn}}
                  </el-menu-item>

                  <el-submenu :index="index2+'ceshi'" v-if="text.isMenus==false&&(text.isPublic==true||$user!=null)"  >
                    <template slot="title">{{ getgeLanguage( text.infoClassNameEn)=='zh'? text.info_CLASS_NAME: text.infoClassNameEn}}</template>

                    <label v-for="(item3,index3) in text.infoMenus" :key="index3+'3级'">
                   <el-menu-item :index="index3+''" v-if="(item3.isPublic3==true||$user!=null)" :route="{path:'/'+item3.router, query:{htmlpath : item3.htmlPath,infoID:info.info_ID,styles:[index2+'',index3+''],active:[index2],threeMenus:item3.info_ID,t: Date.now()}}" >{{ getgeLanguage( item3.infoMenusNameEn)=='zh'? item3.info_NAME: item3.infoMenusNameEn}} </el-menu-item>
</label>
                  </el-submenu>
                  
                </label>
                </el-submenu>
              </el-menu>

</el-dialog>
    </div>
  </div>


</template>

<script>
import {getLocaltype} from '../mainConfig/thu'
export default {
  created() {
    this.getInfo()
  },
  data() {
    return {
      infolist: [],
      menusClass: 'menusClass',
      index: '',
      activeIndex2: '1',
      isActive: '',
      index: '',
      submenuIsActive: '',
      boderbuttomData: 'boderbuttom',
      showMenu:false,
    }
  },
  methods: {
    refresh() {
    location.reload();
  }
,getLocaltypes(){
  return getLocaltype();
},
    getInfo() {
      this.axios.post("/info/getInfo")
        .then(resp => {
          if (resp.data.status == 1) {
            this.infolist = resp.data.result;
            // console.log(resp.data.result)                               
          } else {
            alert("拿取数据失败")
          }
        })
        .catch((err) => {
          // alert("出错了")
          console.log(err)
        })
    },
    getmenusClass(data, index) {
      this.submenuIsActive = index
      this.isActive = data.info_CLASS_ID
    },
    delmenusClass(index) {
      this.isActive = ''
      this.submenuIsActive = ''
    },
    handleOpen(key, keyPath) {
      this.index = key
    },
    handleClose(key, keyPath) {
    },
    handSelect(){
      this.showMenu=false
    },
    getSubmenuIsActive(data) {
      this.submenuIsActive = data
    },
    changeLanguage(){
            this.$i18n.locale=='zh'?this.$i18n.locale='en':this.$i18n.locale='zh'   //设置中英文模式
            localStorage.setItem('languageSet',this.$i18n.locale)   //将用户设置存储到localStorage以便用户下次打开时使用此设置
            this.refresh()
        },
               getgeLanguage(data){
       let language=localStorage.getItem('languageSet')
       if(language==null||data==null){
        return 'zh'
       }else{
        return language
       }
        }
  }
}
</script>

<style  lang="less" scoped>
.mytop {
  width: 100%;
  height: 95px;
  position: fixed;
  top: 0; // 距离底部0
  z-index: 9999; // 当前层为9999层，防止别的元素覆盖
}

.head {
  width: 100%;
  height: 28.48px;
  background: #386afa;
  margin: auto;
}

.headbutton {
  width: 100%;
  background: #0065bd;
}

.topfont {
  margin: auto;
  width: 1400px;
  font-size: 12px;
  text-align: right;
  height: 100%;
  padding-top: 5px;
}

.topfont a {
  margin-right: 8px;
  color: #fff;
}

.headfont {
  width: 1400px;
  height: 100%;
  background-color: aliceblue;
  margin: auto;
  font-weight: bold;
  justify-content: space-evenly;
}

.dd {
  width: 80%;
  height: 100%;
  background-size: 78.092% 70.857%;
  background-repeat: no-repeat;
  background-position: 50% 50%;
 
  // background-image: url("http://www.ebookware.cn/video/blue_saw_logo2.png")
   background-image: url("/static/saw_new_logo.jpg")
}

.ments {
  width: 283px;
  height: 100%;
}

.el-menu--horizontal /deep/ .el-menu-item {
  // height: 66.46px; 
  // height: 100%;
  height: 70px;
}

.el-submenu /deep/.el-submenu__title {
  font-size: 16px;
}

.RoterMain {
  width: 100%;
  background-color: #006179;
  height: 400px;
}

.el-main {
  padding: 0px;
  //  background: -webkit-gradient(linear, 0% 0%, 0% 55%, from(#E7E9FF), to(#FFFFFF));
}

.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}


.el-menu-item {
  font-size: 16px;
  // height: 92px;
  // line-height: 92px;
  transition: none !important;
}

.menusClass {
  color: #FFF200 !important;
}

.menusClass /deep/ .el-submenu__title:hover {
  color: #FFF200 !important;
}

.boderbuttom /deep/ .el-submenu__title {
  border-bottom-color: rgb(255, 208, 75) !important;
  border-bottom: 5px solid;
}

.el-menu--horizontal /deep/ .el-submenu.is-active .el-submenu__title {
  border-bottom: 5px solid #006179;
  color: #303133;
}

.el-menu--horizontal /deep/ .el-menu-item.is-active {
  border-bottom: none;
  /* color: #303133; */
}

.viewList {
  margin-top: 90px;
}

.footerBar2{

display: block;
 height: 160px;
  width: 100%;
  min-width: 1200px;
  margin-top:60px;
 
  background: #0065bd; 
  color:white;
}
.contentBox{

  width:1200px;
  margin: auto;
  height: 150px;
}

.footer_logo
{
    float: left;
    /* margin-left: 100px; */
    width: 120px;
    height: 50px;
    padding: 17.5px 12.75px;
    /* background: url(http://www.ebookware.cn/video/blue_saw_logo2.png);
    background-size:'100px 50px'; */
}
.footer_left
{
  float: left;
  width: 300px;
  margin-left: 60px;
 padding: 8px 0px 12px 10px;
    /* background: url("http://www.ebookware.cn/video/blue_saw_logo2.png") no-repeat left center; */
}

.footer_mid
{
    float: left;
    margin-left:60px;
    padding: 8px 0px 12px 10px;
    position: relative;
}

.footer_right
{
    float: left;
    margin-left: 100px;
    /* margin-top: 15px; */
     padding: 8px 0px 12px 10px;
}
a{
  color:white;
  text-decoration: none;
}
/* ul li{
  text-decoration: none;
} */
.con {
    display: true;
    position: relative;
    bottom: 47px;
    left: 50%;
    z-index: 1000;
    margin-left: -40px;
    margin-top: 60px;
    width: 80px;
}
img{
  overflow:hidden;
  width: 100%;
  height: 100%;
}
.loginandregister
{
  margin-right: 20px;
  padding-right: 220px;
}

</style>


// WEBPACK FOOTER //
// src/components/work/top.vue